import { createContext } from 'react';
export var context = createContext({});
export var Provider = context.Provider;
export var Consumer = context.Consumer;
